import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Richiesta {
  titolo: string;
  testo: string;
  conferma: string;
  risolvi: (ok: boolean) => void;
}

let apri: ((r: Richiesta) => void) | null = null;

/**
 * Una domanda si/no chiesta da codice che non ha un componente suo, come i
 * servizi: il dialogo vive una volta sola in App. Senza App montata si
 * ripiega sulla conferma del browser.
 */
export const chiediConferma = (r: Omit<Richiesta, 'risolvi'>): Promise<boolean> =>
  new Promise(resolve => {
    if (!apri) {
      resolve(window.confirm(r.testo));
      return;
    }
    apri({ ...r, risolvi: resolve });
  });

const ConfermaGlobale: React.FC = () => {
  const { t } = useTranslation();
  const [richiesta, setRichiesta] = useState<Richiesta | null>(null);

  useEffect(() => {
    apri = setRichiesta;
    return () => { apri = null; };
  }, []);

  const chiudi = (ok: boolean) => {
    richiesta?.risolvi(ok);
    setRichiesta(null);
  };

  return (
    <Dialog open={!!richiesta} onClose={() => chiudi(false)} maxWidth="xs" fullWidth>
      <DialogTitle>{richiesta?.titolo}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">{richiesta?.testo}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => chiudi(false)}>{t('cancel', 'Annulla')}</Button>
        <Button variant="contained" color="warning" onClick={() => chiudi(true)}>{richiesta?.conferma}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfermaGlobale;
